import { FC } from "react";
import { IonIcon } from "@ionic/react";
import { ellipse, ellipseOutline } from "ionicons/icons";
import {
  Difficulty,
  DIFFICULTY_LEVELS,
  getDifficultyLevel,
} from "../../common/difficulty";

interface DifficultyDotsProps {
  value?: Difficulty | null;
  /** Makes the dots clickable; clicking the current level clears it (null). */
  onChange?: (value: Difficulty | null) => void;
  size?: number;
}

/** Four dots, the first `value` of them filled. */
export const DifficultyDots: FC<DifficultyDotsProps> = ({
  value,
  onChange,
  size = 14,
}) => {
  const level = getDifficultyLevel(value);

  return (
    <span
      role={onChange ? undefined : "img"}
      aria-label={
        onChange ? undefined : `Nivo težine: ${level ? level.label : "–"}`
      }
      style={{ display: "inline-flex", alignItems: "center", gap: 2 }}
    >
      {DIFFICULTY_LEVELS.map((l) => {
        const filled = !!value && l.value <= value;
        const icon = (
          <IonIcon
            icon={filled ? ellipse : ellipseOutline}
            style={{
              fontSize: size,
              display: "block",
              color: filled
                ? "var(--ion-color-primary)"
                : "var(--ion-color-medium)",
            }}
          />
        );

        return onChange ? (
          <button
            key={l.value}
            type="button"
            title={l.label}
            aria-label={l.label}
            aria-pressed={value === l.value}
            onClick={() => onChange(value === l.value ? null : l.value)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 2,
            }}
          >
            {icon}
          </button>
        ) : (
          <span key={l.value}>{icon}</span>
        );
      })}
    </span>
  );
};
